import React from 'react';

export const highlightText = (
  text: string,
  searchTerm: string
): string | React.ReactNode => {
  if (!searchTerm || !text) {
    return text;
  }

  // Split search term into individual terms and filter out empty strings
  const searchTerms = searchTerm
    .trim()
    .split(/\s+/)
    .filter((term) => term.length > 0);

  if (searchTerms.length === 0) {
    return text;
  }

  // Escape special regex characters for each term and join with OR operator
  const escapedTerms = searchTerms.map((term) =>
    term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  );
  const regex = new RegExp(`(${escapedTerms.join("|")})`, "gi");

  // Check if there's actually a match before splitting
  if (!regex.test(text)) {
    return text;
  }

  const parts = text.split(regex);

  return parts.map((part, index) => {
    // Check if this part matches any of the search terms (case-insensitive)
    const isMatch = searchTerms.some(
      (term) => part.toLowerCase() === term.toLowerCase()
    );

    if (isMatch) {
      return (
        <span key={index} className="font-bold underline">
          {part}
        </span>
      );
    }
    return part;
  });
};
